export function currentYear () {
    return new Date().getFullYear()
}

export const displayDateFormat = 'MM/DD/YYYY';
